import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import RadioField from "."

export default function RadioFieldWrapper({ name, ...rest }) {
  const { field, error, helpers } = useFastField(name)
  const { setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])

  return (
    <RadioField
      {...field}
      error={error}
      onChange={onChange}
      selectedOption={field.value}
      {...rest}
    />
  )
}

RadioFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
